import { useQuery } from '@tanstack/react-query';

import { QrAuthState, QrAuthStatus } from '../types';

import { axios } from '@/libraries/axios';
import { QueryConfig, queryClient } from '@/libraries/react-query';

type QrAuthResponse = { qrAuth: QrAuthState | null };

export const getQrAuth = (pageId: string): Promise<QrAuthResponse> => {
  return axios.get(`/telegram/pages/${pageId}/qr-auth`);
};

export const TERMINAL_QR_AUTH_STATUSES: QrAuthStatus[] = ['ready', 'passwordRequired', 'failed'];

/** Statuses after which the page stays connected server-side, so `['pages']` goes stale. */
export const CONNECTED_QR_AUTH_STATUSES: QrAuthStatus[] = ['ready', 'passwordRequired'];

const FIRST_LINK_INTERVAL_MS = 1000;
const ROTATION_INTERVAL_MS = 3000;

type UseGetQrAuth = {
  pageId: string;
  config?: QueryConfig<typeof getQrAuth>;
};

export const useGetQrAuth = ({ pageId, config = {} }: UseGetQrAuth) => {
  return useQuery<QrAuthResponse>({
    refetchInterval: (data, query) => {
      const status = data?.qrAuth?.status;
      if (
        query.state.status === 'error' ||
        (status && TERMINAL_QR_AUTH_STATUSES.includes(status))
      ) {
        return false;
      }
      return data?.qrAuth?.link ? ROTATION_INTERVAL_MS : FIRST_LINK_INTERVAL_MS;
    },
    cacheTime: 0,
    onSuccess: ({ qrAuth }) => {
      if (qrAuth && CONNECTED_QR_AUTH_STATUSES.includes(qrAuth.status)) {
        queryClient.invalidateQueries(['pages']);
      }
    },
    ...config,
    queryKey: ['telegram-qr-auth', pageId],
    queryFn: () => getQrAuth(pageId),
  });
};
